module.exports = __webpack_public_path__ + "static/gotland-calendar2021-e9798c5062574ef6c24525b8398d83a9.jpg";